import { QueryClient, useQuery } from '@tanstack/react-query';
import { SIMULATION_ENDPOINT_PREFIX } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { GVTData, Response } from 'routes/HumanResourcesModule/business/types';
import { RQAPICallWithData } from 'store/APIClient';

const GVT_DATA_API_KEY = 'hr_simulation_data';

export const resetGVTDataQueries = (queryClient: QueryClient) => {
    queryClient.resetQueries({ queryKey: [GVT_DATA_API_KEY] });
};

export const invalidateGVTDataQuery = (
    queryClient: QueryClient,
    simulationId: number,
) => {
    queryClient.invalidateQueries({
        queryKey: [GVT_DATA_API_KEY, simulationId],
    });
};
export type CostPerYearT = {
    [year: number]: number;
};
export type SmicTotalData = {
    indiciaireCost: number;
    nonIndiciaireCost: number;
    totalCost: number;
};

export type SmicValuesPerYear = {
    indiciaireCost: CostPerYearT;
    nonIndiciaireCost: CostPerYearT;
    perYearCost: CostPerYearT;
};

type GVTTotalAndPerYearData = {
    hrSimulationData: Response<GVTData>;
    smicTotalCost: SmicTotalData;
    indexPointTotalCost: number;
    indexRaiseTotalCost: number;
    rateCnraclTotalCost: number;
    echelonTotalCost: number;
    freeHypothesisTotals: Record<string, number>;
    smicPerYear: SmicValuesPerYear;
    indexPointPerYear: CostPerYearT;
    indexRaisePerYear: CostPerYearT;
    rateCnraclPerYear: CostPerYearT;
    echelonPerYear: CostPerYearT;
    freeHypothesisPerYear: Record<string, CostPerYearT>;
};

export const useGetHrGVTData = (payStateId: number) =>
    useQuery({
        queryKey: [GVT_DATA_API_KEY, payStateId],

        queryFn: async () => {
            const response = await RQAPICallWithData<GVTTotalAndPerYearData>({
                endpoint: `${SIMULATION_ENDPOINT_PREFIX}/${payStateId}/gvt/simulation_data`,
            });
            return response.content.data;
        },
    });
